<template>
	<div>
		<Toolbar class="p-mb-4">
			<template v-slot:left>
				<Button label="返回" icon="pi pi-arrow-left" class="p-button-warning p-mr-3" @click="$router.push({name: 'submission'})" />
				<Button label="暂存" icon="pi pi-save" class="p-button-success p-mr-3" @click="saveSummary" />
			</template>

			<template v-slot:right>
				<Button label="提交总结" icon="pi pi-check" class="p-button-primary p-mr-2" @click="onSubmitClick" />
			</template>
		</Toolbar>

		<div class="p-grid">
			<div class="p-col-12 p-md-6">
				<div class="card p-fluid">
					<h4 style="color: RGB(22,105,196)">项目基本信息</h4>
					<div class="p-field">
						<label>实验名称 <span style="color: red">*</span></label>
						<InputText type="text" v-model="summary.experimentName" />
					</div>
					<div class="p-field">
						<label>申请类型 <span style="color: red">*</span></label>
						<Dropdown v-model="summary.applicationType" :options="applicationTypeOptions" placeholder="-- 请选择 --" />
					</div>
					<div class="p-field">
						<label>项目来源和性质 <span style="color: red">*</span></label>
						<Dropdown v-model="summary.projectProperty" :options="projectPropertyOptions" placeholder="-- 请选择 --" />
					</div>
					<div class="p-field">
						<label>实验开始时间 <span style="color: red">*</span></label>
						<Calendar v-model="startDate" :showTime="true" :showIcon="true" dateFormat="yy-mm-dd" @hide="onStartEndDatePanelHide" />
					</div>
					<div class="p-field">
						<label>实验结束时间 <span style="color: red">*</span></label>
						<Calendar v-model="endDate" :showTime="true" :showIcon="true" dateFormat="yy-mm-dd" @hide="onStartEndDatePanelHide" />
					</div>
					<div class="p-field">
						<label>分配机时（小时）</label>
						<i v-if="beamTimeLoading" class="fa fa-spinner fa-pulse fa-2x fa-fw" style="color: RGB(22,105,196)"></i>
						<InputText type="text" :disabled="true" v-model="summary.beamtime" />
					</div>

					<h4 style="color: RGB(22,105,196)">实验负责人信息</h4>
					<div class="p-field">
						<label>姓名 <span style="color: red">*</span></label>
						<InputText type="text" v-model="summary.ownerName" />
					</div>
					<div class="p-field">
						<label>单位 <span style="color: red">*</span></label>
						<InputText type="text" v-model="summary.ownerOrganization" />
					</div>
					<div class="p-field">
						<label>电话 <span style="color: red">*</span></label>
						<InputText type="text" v-model="summary.ownerPhone" />
					</div>

					<h4 style="color: RGB(22,105,196)">
						<span style="vertical-align: middle; margin-right: 10px">实验参与人员</span>
						<Button type="button" label="添加" icon="pi pi-plus-circle" class="p-button-sm p-button-success" style="width: 80px; vertical-align: middle" @click="onAddParticipantClick" />
					</h4>
					<DataTable :value="summary.participants" responsiveLayout="scroll">
						<Column field="name" header="姓名"></Column>
						<Column field="organization" header="单位"></Column>
						<Column field="phone" header="电话"></Column>
						<Column headerStyle="width: 10%">
							<template #header>
								<i class="pi pi-cog" style="font-size: 1.5em" v-tooltip.top="'操作'"></i>
							</template>
							<template #body="slotProps">
								<Button type="button" label="删除" icon="pi pi-times-circle" class="p-button-sm p-button-danger" style="width: 80px" @click="removeParticipant(slotProps.index)" />
							</template>
						</Column>
						<template #empty>
							No records found.
						</template>
					</DataTable>
				</div>
			</div>

			<div class="p-col-12 p-md-6">
				<div class="card p-fluid">
					<h4 style="color: RGB(22,105,196)">样品及质子束流需求</h4>
					<div class="p-field">
						<label>样品类型及名称 <span style="color: red">*</span></label>
						<InputText type="text" v-model="summary.sampleType" placeholder="如：IGBT芯片" />
					</div>
					<div class="p-field">
						<label>质子能量范围（0-80MeV） <span style="color: red">*</span></label>
						<InputText type="text" v-model="summary.protonEnergyRange" placeholder="如：30MeV" />
					</div>
					<div class="p-field">
						<label>质子束斑大小（方形束斑，2mm*2mm - 50mm*50mm）<span style="color: red">*</span></label>
						<InputText type="text" v-model="summary.protonBeamSpotSize" placeholder="如：2mm*2mm, 10mm*10mm" />
					</div>

					<h4 style="color: RGB(22,105,196)">实验内容</h4>
					<div class="p-field">
						<Textarea v-model="summary.experimentContent" placeholder="如：完成芯片的测试" :autoResize="true" rows="18" cols="30" />
					</div>
				</div>
			</div>
		</div>

		<Dialog v-model:visible="addParticipantDialog" header="添加参与人员" :modal="true" class="p-fluid">
			<div class="p-field">
				<label>姓名</label>
				<InputText v-model.trim="submittingParticipant.name" autofocus />
			</div>
			<div class="p-field">
				<label>单位</label>
				<InputText v-model.trim="submittingParticipant.organization" autofocus />
			</div>
			<div class="p-field">
				<label>电话</label>
				<InputText v-model.trim="submittingParticipant.phone" autofocus />
			</div>

			<template #footer>
				<Button label="取消" icon="pi pi-times" class="p-button-text" @click="addParticipantDialog=false"/>
				<Button label="确定" icon="pi pi-check" class="p-button-primary" @click="addParticipant(submittingParticipant)" />
			</template>
		</Dialog>

		<Dialog v-model:visible="submitSummaryDialog" :style="{width: '450px'}" header="消息确认" :modal="true">
			<div>
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2em; color: orange; vertical-align: middle;" />
				<span style="color: orange; font-size: 1.2em;">确定要提交提案总结吗?</span>
			</div>
			<template #footer>
				<Button label="取消" icon="pi pi-times" class="p-button-text" @click="submitSummaryDialog = false"/>
				<Button label="确定" icon="pi pi-check" class="p-button-primary" @click="submitSummary" />
			</template>
		</Dialog>
	</div>
</template>
<script>
import ProposalService from '../service/ProposalService';
const moment = require('moment');

export default {
	data() {
		return {
			summary: {},

			applicationTypeOptions: null,
			projectPropertyOptions: null,
			proposal: {},
			submittingParticipant: {},
			addParticipantDialog: false,
			submitSummaryDialog: false,

			beamTimeLoading: false,
		}
	},

	proposalService: null,

	created() {
		this.proposalService = new ProposalService();
	},

	mounted() {
		this.applicationTypeOptions = this.proposalService.getApplicationTypeOptions();
		this.projectPropertyOptions = this.proposalService.getProjectPropertyOptions();
		this.fetchProposal();
	},

	beforeRouteUpdate() {
		// react to route changes...
		// don't forget to call next()
		console.log('beforeRouteUpdate');
		console.log(this.$route.params);
		console.log(this.$route.params.id);
	},

	beforeRouteLeave() {
		// called when the route that renders this component is about to
		// be navigated away from.
		// has access to `this` component instance.
		// this.stopAutoSave();
		console.log('beforeRouteLeave');
	},

	methods: {
		onSubmitClick() {
			let validity = this.proposalService.validateProposalSummary(this.summary);
			if(!validity.valid) {
				this.$toast.add({ severity: 'error', summary: '操作失败', detail: validity.message });
				return;
			}

			this.submitSummaryDialog = true;
		},
		fetchProposal() {
			console.log('fetchProposal');
			console.log(this.$route.params.id);

            this.proposalService.findSingleProposal(this.$route.params.id)
            .then(proposal => {
				if(proposal.summary && proposal.summary.number) {
					this.summary = proposal.summary;
				} else {
					this.summary.number = proposal.number;
					this.summary.experimentName = proposal.experimentName;
					this.summary.projectProperty = proposal.projectProperty;
					this.summary.ownerName = proposal.ownerName;
					this.summary.ownerOrganization = proposal.ownerOrganization;
					this.summary.ownerPhone = proposal.ownerPhone;
					this.summary.participants = proposal.participants;
					
					this.summary.sampleType = proposal.sampleType;
					this.summary.protonEnergyRange = proposal.protonEnergyRange;
					this.summary.protonBeamSpotSize = proposal.protonBeamSpotSize;
					
					let now = new Date();
					this.startDate = this.endDate = now.setMinutes(0, 0);
				}
            });
        },
		saveSummary() {
            this.proposalService.saveSummary(this.$route.params.id, this.summary).then((proposal) => {
                // this.$router.push({name: 'submission'});
				this.$router.push({ name: 'summarize', params: { id: proposal._id } });
				this.$toast.add({severity: 'info', summary: '已暂存', life: 5000});
				console.log(this.$route.params);
            }).catch((error) => {
                if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
            });
        },
		submitSummary() {
            this.proposalService.submitSummary(this.$route.params.id, this.summary).then(() => {
                this.$router.push({name: 'submission'});
            }).catch((error) => {
                if(error.response) {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
				} else {
					this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
				}
            });
        },
		onAddParticipantClick() {
			this.submittingParticipant = {};
			this.addParticipantDialog = true;
		},
		addParticipant(participant) {
			if(!this.summary.participants)  this.summary.participants = [];
			this.summary.participants.push(participant);
			this.addParticipantDialog = false;
		},
		removeParticipant(index) {
			console.log(this.summary.participants);
            this.summary.participants.splice(index, 1);
			console.log(this.summary.participants);
		},
		onStartEndDatePanelHide() {
			console.log('Start or end Panel Hide');
			this.beamTimeLoading = true;

			if(this.summary.startDate && this.summary.endDate) {
				this.proposalService.calculateBeamTime(this.summary.startDate, this.summary.endDate)
				.then((data) => {
					this.summary.beamtime = data.beamtime;
				}).catch((error) => {
					if(error.response) {
						this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.response.data.message });
					} else {
						this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
					}
				}).finally(() => {
					this.beamTimeLoading = false;
				});
			}
		},
	},

	computed: {
        startDate: {
            get() {
				if(this.summary.startDate) {
					let d = new Date(this.summary.startDate);
					d.setMinutes(0, 0);
					return d;
				} else {
					return null;
				}
            },
            set(value) {
                this.summary.startDate = moment(value).format("YYYY-MM-DD HH:mm:ss");
            }
        },
		endDate: {
            get() {
				if(this.summary.endDate) {
					let d = new Date(this.summary.endDate);
					d.setMinutes(0, 0);
					return d;
				} else {
					return null;
				}
            },
            set(value) {
                this.summary.endDate = moment(value).format("YYYY-MM-DD HH:mm:ss");
            }
        },
        loggedIn() {
            return this.$store.state.authentication.status.loggedIn;
        },
        userInfo() {
            return this.$store.state.authentication.user;
        }
    },

	watch: {
		// $route() {
		// 	// react to route changes...
		// 	console.log('watch');
		// 	console.log(this.$route.params);
		// 	console.log(this.$route.params.id);
			
		// 	if(this.$route.params && this.$route.params.id) {
		// 		this.fetchProposal();
		// 	}
		// }
	}
}
</script>
